import type { GCColor } from '@components/atoms/gccolors';

export const IconSizes = {
    // consult with design before adding new sizes
    // Avatar sizes from the design sizing table, named like `sizing-5x` below. 120px is off the table.
    'sizing-30x': 120,
    xxlarge: 115,
    xlarge: 96,
    'sizing-18x': 72,
    large: 48,
    'sizing-10x': 40,
    medium: 32,
    small: 24,
    /**
     * Design confirmed 20px belongs in the scale, but the t-shirt names have no room between
     * `small` and `xsmall`, and renumbering either one would move every existing caller. So it
     * deliberately carries the semantic name the Themed Icon will use. That way the `sizing-*` entries
     * stand out as the ones that do not belong on this scale and get deleted once that component exists.
     */
    'sizing-5x': 20,
    xsmall: 16,
    xxsmall: 12,
};

export type IconSize = keyof typeof IconSizes;

/**
 * `currentColor` makes the icon take the `color` of whatever renders it. A themed component can
 * then let its icons follow its own text color in every state, instead of the caller naming a
 * palette color for each one. This is a workaround until we create a Themed Icon.
 */
export type IconFill = GCColor | 'currentColor';

export interface IconProps {
    fill?: IconFill;
    stroke?: GCColor;
    size?: IconSize;
    width?: number;
    height?: number;
    className?: string;
}
